import {Injectable} from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExpertService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  private url = 'api/expert';
  getUrl(): string {
    return this.url;
  }

  /** PUT: 提交并保存 */
  saveAndCommit(object:any):Observable<any> {
    return this.http.put<any>(this.getUrl()+"/save-and-commit", object, httpOptions).pipe(
      tap(_ => this.log(`updated object =${object}`)),
      catchError(
        this.handleError<any>('updateany')
      )
    );
  }

  /** GET 提交 */
  commit(params: HttpParams): Observable<any[]>{
    return this.http.get<any>(this.url+"/commit", {
      headers:httpOptions.headers,
      observe: 'response',//完整数据返回，包括抬头
      params: params}
    ).pipe(
      tap(_ => this.log(`searchWorkflowType`)),
      catchError(this.handleError<any>(`searchWorkflowType`))
    );
  }
}
